import _ from "lodash";

import { createFilter } from ".";

_.mixin({
	search(items, filter) {
		return items.filter(createFilter(filter));
	}
});
